import apiService from "@/services/apiService";

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export default {
  namespaced: true,

  state: () => ({
    savedSearches: [],
    savedSearchesListings: [],
    similarListings: [],
    loading: false,
    error: null,
    lastFetch: null,
    isInitialized: false,
    lastFetchedUserId: null, // NEW
    // ✅ REMOVED: authChecked - not needed anymore
  }),

  mutations: {
    SET_SAVED_SEARCHES(state, searches) {
      state.savedSearches = searches;
      // console.log('✅ SET_SAVED_SEARCHES:', {
      //   count: searches.length,
      //   samples: searches.slice(0, 2).map(s => ({
      //     id: s.id,
      //     name: s.name,
      //     listingsCount: s.savedListings?.length || 0
      //   }))
      // });
    },

    SET_SAVED_SEARCHES_LISTINGS(state, listings) {
      state.savedSearchesListings = listings;
      // console.log('✅ SET_SAVED_SEARCHES_LISTINGS:', {
      //   count: listings.length,
      //   samples: listings.slice(0, 2).map(l => ({
      //     id: l.id,
      //     title: l.title,
      //     fromSavedSearch: l.fromSavedSearch
      //   }))
      // });
    },

    SET_SIMILAR_LISTINGS(state, listings) {
      state.similarListings = listings;
    },

    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },

    SET_ERROR(state, error) {
      state.error = error;
    },

    SET_LAST_FETCH(state, timestamp) {
      state.lastFetch = timestamp;
    },

    SET_INITIALIZED(state, value) {
      state.isInitialized = value;
    },

    CLEAR_ERROR(state) {
      state.error = null;
    },
    SET_LAST_FETCHED_USER_ID(state, userId) {
      state.lastFetchedUserId = userId ?? null;
    },
  },

  actions: {
    // ✅ SIMPLIFIED: Initialize for all users
    async initialize({ commit, dispatch, getters }) {
      commit("SET_LOADING", true);
      commit("CLEAR_ERROR");

      try {
        // Step 1: Always fetch similar listings (works for everyone)
        await dispatch("fetchSimilarListings");

        // Step 2: Try to fetch saved searches (only works for authenticated users)
        await dispatch("fetchSavedSearches");

        // Step 3: Match with existing listings if we have saved searches
        if (getters.allSearches.length > 0) {
          await dispatch("fetchSavedSearchesListings");
        }

        commit("SET_INITIALIZED", true);
      } catch (error) {
        console.error("❌ SavedSearches initialization failed:", error);
        commit(
          "SET_ERROR",
          error.message || "Failed to initialize saved searches"
        );
        commit("SET_INITIALIZED", false);
      } finally {
        commit("SET_LOADING", false);
      }
    },

  

    // ✅ NEW: Fetch similar listings for all users
    async fetchSimilarListings({ commit, rootState }) {
      try {
        const response = await apiService.recentlyViewed.getSimilarListings({
          limit: 10,
          hours: 168, // 7 days
        });

        if (response.data?.data) {
          // console.log(`✅ Found ${response.data.data.length} similar listings`);
          commit("SET_SIMILAR_LISTINGS", response.data.data);

          // ✅ ADD: Set flag in RecentlyViewedStore to prevent duplicate calls
          if (rootState.recentlyViewed) {
            rootState.recentlyViewed.similarListingsFetched = true;
          }
        } else {
          //  console.log('ℹ️ No similar listings found');
          commit("SET_SIMILAR_LISTINGS", []);
        }
      } catch (error) {
        // console.log('ℹ️ Similar listings not available:', error.message);
        // Don't throw error, just set empty array
        commit("SET_SIMILAR_LISTINGS", []);
      }
    },

   

    // async fetchSavedSearches({ commit, state, rootState }) {
    //   const currentUserId = rootState.auth?.user?.id ?? null;
    //   console.log("[savedSearches] currentUserId:", currentUserId);

    //   // cache check...
    //   try {
    //     const response = await apiService.savedSearches.getSavedSearches();
    //     console.log("[savedSearches] GET /searches status:", response.status);
    //     console.log(
    //       "[savedSearches] raw length:",
    //       response?.data?.data?.length
    //     );

    //     const all = response.data.data.map((s) => ({
    //       ...s,
    //       savedListings: Array.isArray(s.saved_listings)
    //         ? s.saved_listings
    //         : [],
    //       searchMetadata: s.search_metadata || {},
    //     }));

    //     commit("SET_SAVED_SEARCHES", all); // <-- keep all
    //     commit("SET_LAST_FETCH", Date.now());
    //     commit("SET_LAST_FETCHED_USER_ID", currentUserId);

    //     // // If you keep the client filter, log what you’re filtering on
    //     // const mine = currentUserId
    //     //   ? all.filter((s) => String(s.user_id) === String(currentUserId))
    //     //   : [];
    //     // console.log("[savedSearches] after filter length:", mine.length);

    //     // commit("SET_SAVED_SEARCHES", mine); // or 'all' if Option B
    //     // commit("SET_LAST_FETCH", Date.now());
    //     // commit("SET_LAST_FETCHED_USER_ID", currentUserId);
    //   } catch (e) {
    //     console.log(
    //       "[savedSearches] error status:",
    //       e.response?.status,
    //       e.message
    //     );
    //     // ...existing error handling
    //   }
    // },


    async fetchSavedSearches({ commit, state, rootState }) {
  const currentUserId = rootState.auth?.user?.id ?? null;

  try {
    const response = await apiService.savedSearches.getSavedSearches();

    const all = (response?.data?.data || []).map((s) => ({
      ...s,
      savedListings: Array.isArray(s.saved_listings) ? s.saved_listings : [],
      searchMetadata: s.search_metadata || {},
    }));

    const mine = currentUserId
      ? all.filter((s) => String(s.user_id) === String(currentUserId))
      : [];

    commit("SET_SAVED_SEARCHES", mine);
    commit("SET_LAST_FETCH", Date.now());
    commit("SET_LAST_FETCHED_USER_ID", currentUserId);
  } catch (e) {
    // 401 → unauthenticated: treat as no searches
    if (e?.response?.status === 401) {
      commit("SET_SAVED_SEARCHES", []);
      commit("SET_LAST_FETCH", Date.now());
      commit("SET_LAST_FETCHED_USER_ID", null);
      return;
    }
    console.log("[savedSearches] error:", e.message);
    commit("SET_SAVED_SEARCHES", []);
    commit("SET_LAST_FETCH", Date.now());
    commit("SET_LAST_FETCHED_USER_ID", currentUserId);
  }
},

   
    async fetchSavedSearchesListings({ commit, state, dispatch, rootState }) {
      if (!state.savedSearches?.length) {
        commit("SET_SAVED_SEARCHES_LISTINGS", []);
        return;
      }

      const currentUserId = rootState.auth?.user?.id ?? null;

      const allListings = await dispatch("getAllAvailableListings");

      const matched = []; // <-- define BEFORE logging
      state.savedSearches.forEach((search) => {
        (search.savedListings || []).forEach((savedListing) => {
          const match = findMatchingListing(savedListing, allListings);
          if (match) {
            matched.push({
              ...match,
              fromSavedSearch: search.name,
              keyword: search.keyword || "",
              savedAt: savedListing.saved_at,
              savedSearchId: search.id,
              savedSearchUserId: currentUserId, // <-- tag with current user
              originalSavedListing: savedListing,
            });
          }
        });
      });

      console.log("[savedSearchesListings] matched:", matched.length); // <-- AFTER it's built
      commit("SET_SAVED_SEARCHES_LISTINGS", matched);
    },

    // ✅ SIMPLIFIED: Get available listings
    async getAllAvailableListings({ rootGetters }) {
      try {
        const propertyListings =
          rootGetters["propertyFilter/allPropertyListings"] || [];
        const filterListings = rootGetters["FilterStore/allListings"] || [];

        const allListings = [...propertyListings, ...filterListings];

        // Remove duplicates by ID
        const uniqueListings = allListings.filter(
          (listing, index, self) =>
            index === self.findIndex((l) => l.id === listing.id)
        );

        //  console.log(`📦 Collected ${uniqueListings.length} unique listings`);
        return uniqueListings;
      } catch (error) {
        // console.error('❌ Error collecting listings:', error);
        return [];
      }
    },

    // ✅ UNCHANGED: Existing actions (these still require authentication)
    async saveSearch({ commit, state, dispatch }, searchData) {
      commit("SET_LOADING", true);
      try {
        const response = await apiService.savedSearches.saveSearch({
          ...searchData,
          saved_listings: JSON.stringify(searchData.savedListings || []),
          search_metadata: JSON.stringify(searchData.searchMetadata || {}),
        });

        const newSearch = {
          ...response.data.data,
          savedListings: searchData.savedListings || [],
          searchMetadata: searchData.searchMetadata || {},
        };

        commit("SET_SAVED_SEARCHES", [newSearch, ...state.savedSearches]);
        await dispatch("fetchSavedSearchesListings");
      } catch (error) {
        commit("SET_ERROR", "Failed to save search");
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteSearch({ commit, state }, id) {
      try {
        await apiService.savedSearches.deleteSearch(id);
        commit(
          "SET_SAVED_SEARCHES",
          state.savedSearches.filter((search) => search.id !== id)
        );
      } catch (error) {
        commit("SET_ERROR", "Failed to delete search");
        throw error;
      }
    },

    // ✅ NEW: Refresh action
    async refresh({ commit, dispatch }) {
      // console.log('🔄 Force refreshing saved searches...');
      commit("SET_LAST_FETCH", null);
      commit("SET_INITIALIZED", false);
      await dispatch("initialize");
    },
  },

  getters: {
    allSearches: (state) => state.savedSearches,

    // displayListings: (state) => {
    //   const savedListings = state.savedSearchesListings || [];
    //   const similarListings = state.similarListings || [];
    //   const combined = [...savedListings, ...similarListings];
    //   // console.log('📊 Display listings getter:', {
    //   //   saved: savedListings.length,
    //   //   similar: similarListings.length,
    //   //   combined: combined.length
    //   // });

    //   return combined;
    // },

    displayListings: (state, _getters, rootState) => {
      const currentUserId = rootState.auth?.user?.id ?? null;
      const savedForUser = currentUserId
        ? (state.savedSearchesListings || []).filter(
            (l) => String(l.savedSearchUserId ?? "") === String(currentUserId)
          )
        : [];
      const similar = state.similarListings || [];
      return [...savedForUser, ...similar];
    },

    getSavedSearches: (state) => {
      // Group matched listings by savedSearchId
      const listingsBySearchId = state.savedSearchesListings.reduce(
        (acc, listing) => {
          const searchId = listing.savedSearchId;
          if (!acc[searchId]) {
            acc[searchId] = [];
          }
          acc[searchId].push(listing);
          return acc;
        },
        {}
      );

      // Attach listings to corresponding saved search
      return state.savedSearches.map((search) => ({
        ...search,
        matchedListings: listingsBySearchId[search.id] || [],
      }));
    },

    slidingDisplayListings: (state) => {
      const savedListings = state.savedSearchesListings || [];
      const similarListings = state.similarListings || [];
      return [...savedListings, ...similarListings];
    },

    // ✅ CHANGED: Show section if we have any content (saved OR similar)
    shouldShowSection: (state) => {
      const hasSearches = state.savedSearches.length > 0;
      const hasSimilar = state.similarListings.length > 0;

      return hasSearches || hasSimilar;
    },

    // ✅ SIMPLIFIED: Keep authentication check but make it optional
    isUserAuthenticated: (state, getters, rootState) => {
      return !!(rootState.auth?.user || rootState.auth?.isAuthenticated);
    },

    isInitialized: (state) => state.isInitialized,
    isLoading: (state) => state.loading,
    hasError: (state) => !!state.error,
    errorMessage: (state) => state.error,
  },
};

// ✅ UNCHANGED: Helper function
function findMatchingListing(savedListing, availableListings) {
  if (!savedListing || !availableListings || !availableListings.length) {
    return null;
  }

  // Strategy 1: Direct ID match
  let match = availableListings.find((listing) => {
    const listingId = String(listing.id);
    const savedId = String(savedListing.id);
    return listingId === savedId;
  });

  if (match) return match;

  // Strategy 2: Title match
  if (savedListing.title) {
    match = availableListings.find((listing) => {
      const listingTitle = listing.title?.toLowerCase().trim();
      const savedTitle = savedListing.title?.toLowerCase().trim();
      return listingTitle === savedTitle;
    });

    if (match) return match;
  }

  // Strategy 3: Reference data matching
  if (savedListing.reference_data) {
    const refData = savedListing.reference_data;

    if (refData.slug) {
      match = availableListings.find(
        (listing) => listing.slug === refData.slug
      );
      if (match) return match;
    }

    if (refData.category_id && refData.price) {
      match = availableListings.find((listing) => {
        const listingCategoryId = listing.category_id || listing.category?.id;
        const categoryMatch =
          String(listingCategoryId) === String(refData.category_id);
        const priceMatch = Math.abs(listing.price - refData.price) < 100;
        return categoryMatch && priceMatch;
      });

      if (match) return match;
    }
  }

  return null;
}
